import {
  Form,
  useCreate,
  useGetIdentity,
  useNotify,
  useRedirect,
} from "ra-core";
import { SaveButton } from "@/components/admin/form";
import { Card, CardContent } from "@/components/ui/card";
import { MeetingInputs } from "./MeetingInputs";
import { buildMeetingTasks } from "./meetingTasks";

export const MeetingCreate = () => {
  const [create, { isPending }] = useCreate();
  const { identity } = useGetIdentity();
  const notify = useNotify();
  const redirect = useRedirect();

  const submit = async (values: Record<string, unknown>) => {
    const {
      contact_ids: contactIds = [],
      create_tasks_from_next_steps: createTasks,
      ...meeting
    } = values;
    try {
      const created = await create(
        "meetings",
        { data: meeting },
        { returnPromise: true },
      );
      await Promise.all(
        (contactIds as number[]).map((contactId) =>
          create(
            "meeting_contacts",
            { data: { meeting_id: created.id, contact_id: contactId } },
            { returnPromise: true },
          ),
        ),
      );
      if (createTasks) {
        await Promise.all(
          buildMeetingTasks(meeting, created.id).map((task) =>
            create("tasks", { data: task }, { returnPromise: true }),
          ),
        );
      }
      notify("Reunión creada", { type: "success" });
      redirect("list", "meetings");
    } catch (error) {
      notify(
        error instanceof Error ? error.message : "No se pudo crear la reunión",
        { type: "error" },
      );
    }
  };

  return (
    <Card className="mx-auto mt-4 w-full max-w-4xl">
      <CardContent>
        <Form onSubmit={submit} defaultValues={{ sales_id: identity?.id }}>
          <MeetingInputs participants taskCreation />
          <div className="mt-6 flex justify-end">
            <SaveButton disabled={isPending} />
          </div>
        </Form>
      </CardContent>
    </Card>
  );
};
